import type { IconSvgObject } from './types';

const Zip02Icon: IconSvgObject = [
  ["path", { d: "M14.5 13.9989V18.9991M12 18.9991H9L12 13.9989H9M17 16.9989V13.9989H19C19.8284 13.9989 20.5 14.6705 20.5 15.4989C20.5 16.3273 19.8284 16.9989 19 16.9989H17ZM17 16.9989V18.9989", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19.5 22H5.5C4.39543 22 3.5 21.1046 3.5 20L3.5 4C3.5 2.89543 4.39543 2 5.5 2H12.5L19.5 9V11M19 9H14.498C13.3935 9 12.498 8.10457 12.498 7V2.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Zip02Icon;
